import {
  faExclamationTriangle,
  faShield,
  faTriangleExclamation,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleModal from "app/components/Modals/SimpleModal";
import Button from "app/storybookComponents/Button";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onConfirm: () => void;
}

const HarmDetectionWarningModal = ({
  isOpen,
  onClose,
  isLoading,
  onConfirm,
}: Props) => {
  return (
    <SimpleModal show={isOpen} onHide={onClose}>
      <div className="-mt-[50px] d-flex align-items-center gap-2">
        <div className="d-flex h-12 w-12 bg-sapphire-10 text-sapphire-100 rounded-xl align-items-center justify-content-center">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-2xl" />
        </div>
        <h2>Enable Harmful Content Detection?</h2>
      </div>
      <p>
        This uses AI to automatically scan check-in responses and flag
        messages that may indicate a safety or HR concern.{" "}
        <b>
          It is a fallback detection layer only — not a guarantee — and it
          can miss real concerns or incorrectly flag messages that aren&apos;t
          concerning.
        </b>
      </p>

      <div className="flex flex-col gap-2 px-4 py-3 bg-charcoal-05 rounded-lg border-[1px] border-charcoal-20 text-charcoal-130">
        <div className="d-flex gap-2">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="text-sapphire-100"
          />
          <p>
            Flagged messages are estimates, not confirmed findings — every
            alert requires human review before any action is taken
          </p>
        </div>
        <div className="d-flex gap-2">
          <FontAwesomeIcon icon={faShield} className="text-sapphire-100" />
          <p>
            This tool does not replace your organization&apos;s existing HR,
            safety, or crisis-reporting processes
          </p>
        </div>
        <div className="d-flex gap-2">
          <FontAwesomeIcon icon={faUsers} className="text-sapphire-100" />
          <p>
            Managers and admins are responsible for exercising independent
            judgment on every alert
          </p>
        </div>
      </div>

      <p>
        By enabling this feature, you acknowledge it is provided as an
        additional layer of support and does not guarantee detection of all
        concerns.
      </p>
      <div className="d-flex w-full">
        <div className="d-flex gap-2 ms-auto">
          <Button
            variant="secondary-gray"
            disabled={isLoading}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button disabled={isLoading} onClick={onConfirm}>
            Enable Detection
          </Button>
        </div>
      </div>
    </SimpleModal>
  );
};

export default HarmDetectionWarningModal;
